// Google OAuth Configuration
export const googleConfig = {
  auth: {
    clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    authUri: 'https://accounts.google.com/o/oauth2/auth',
    tokenUri: 'https://oauth2.googleapis.com/token',
    redirectUri: `${window.location.origin}/auth/callback/google`,
  }
};

// OAuth exchange endpoint - server-side token exchange
export const oauthExchangeConfig = {
  // Edge function that exchanges auth code for tokens using client secret
  exchangeEndpoint: '/functions/v1/oauth-exchange',
};

// Google OAuth scopes for Calendar access
export const googleScopes = [
  'https://www.googleapis.com/auth/calendar.readonly', // Read calendar events
  'https://www.googleapis.com/auth/calendar.events', // Create/update/delete events
  'email', // Get user's email
  'profile', // Get user's basic profile
  'openid', // OpenID Connect
];

// Google Calendar API endpoints
export const googleCalendarConfig = {
  calendarApiEndpoint: 'https://www.googleapis.com/calendar/v3',
  userInfoEndpoint: 'https://www.googleapis.com/oauth2/v3/userinfo',
};

// Calendar sync specific settings (shared with Outlook)
export const calendarSyncConfig = {
  // Default sync range
  defaultSyncDays: 30,
  maxSyncDays: 90,

  // Event filtering
  excludeAllDayEvents: false, // All-day events are now handled properly (marked as full-day busy slots)
  excludeCancelledEvents: true,
  onlySyncBusyEvents: true,

  // Time range restrictions (golf hours)
  syncStartHour: 6, // 6 AM
  syncEndHour: 22,  // 10 PM

  // Sync frequency
  autoSyncIntervalHours: 24,

  // Event status to sync (Google uses 'confirmed', 'tentative', 'cancelled')
  syncEventStatuses: ['confirmed', 'tentative']
};
